export const CORE_AMZL = "AMZL_CORE";
export const AR_V2 = "AR_NEXT_GEN";
export const AR = "AR";
export const SSD = "SSD";
export const CART_VIEW = "CART_VIEW";
export const ROUTE_VIEW = "ROUTE_VIEW";
export const PLAN_MANAGEMENT_VIEW = "PLAN_MANAGEMENT_VIEW";
export const STAGE_BY_TIME_THRESHOLD = 30 * 60 * 1000;
export const EMPTY_STRING = "";
export const TIMEOUT_STRING = "timeout";
export const DEFAULT_REFRESH_INTERVAL = 60 * 1000;  // 1 minute.
export const MILLIS_IN_SECOND = 1000;
export const DOCK_DOOR = "DOCK_DOOR";
export const IS_RSWS_BOSON_FLOW_ENABLED = "isRSWSBosonFlowEnabled";
export const IS_ROUTE_ADJUSTMENT_ENABLED = "isRouteAdjustmentEnabled";

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"],
    tr: ["tr", "tr-TR"]
}

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light"
}

export const LOCALE = {
    AR: "ar",
    DE: "de",
    EN: "en",
    ES: "es",
    FR: "fr",
    IT: "it",
    JA: "ja",
    TR: "tr",
}

export const LOCALE_DIRECTION = {
    RIGHT_TO_LEFT: "rtl",
    LEFT_TO_RIGHT: "ltr",
}

export const TIMEOUTS = {
    RSWS_GET_STATION_ROUTES_API_TIMEOUT: 45000,
    RSWS_DEFAULT_API_TIMEOUT: 25000,
}

export const STAGE_LOCATION_TYPE = {
    PLANNED: "PLANNED",
    NORMAL: "NORMAL",
    OVERFLOW: "OVERFLOW",
}

export const DWP_FILE_UPLOAD_SOURCE = {
    AUTO: "auto",
    MANUAL: "manual"
}

export const DEFAULT_CAPABILITIES = [CORE_AMZL, SSD, AR];

export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour:'2-digit',
    minute:'2-digit',
    second:'2-digit',
    timeZoneName: 'short',
    hourCycle:'h24'
}

/** Worst case API latency is assumed to be 10 sec */
export const CACHE_TTL = 50000;

export const PAGE_HEADERS = {
    STAGE: {
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound",
        head: "stage.heading",
        headAlt: "Stage",
        desc: "stage.description",
        descAlt: "This table shows routes’ status and details during the outbound stage process"
    },
    DEPART: {
        tab: "outboundAMZL.tabHeading",
        tabAlt: "Outbound",
        head: "depart.heading",
        headAlt: "Depart",
        desc: "depart.description",
        descAlt: "This table shows routes’ status and details during the outbound depart process"
    }
}

export const STAGE = {
    DEV: "dev",
    BETA: "beta",
    GAMMA: "gamma",
    PROD: "prod"
}

export const REGION = {
    NA: "US",
    EU: "EU",
    JP: "JP",
    IN: "IN"
}

export const ENVIRONMENT = {
    DEV: "development",
    TEST: "test",
    PROD: "production"
}

export const DEPART_TABLE_ACTIONS = {
    BULK_UPDATE_ROUTE_STATUS_MODAL: "BULK_UPDATE_ROUTE_STATUS_MODAL",
    BULK_UPDATE_ROUTE_STATUS: "BULK_UPDATE_ROUTE_STATUS",
    BULK_SUCCESS_NOTIFICATION_UPDATE: "BULK_SUCCESS_NOTIFICATION_UPDATE",
    CLOSE_BULK_UPDATE_NOTIFICATION: "CLOSE_BULK_UPDATE_NOTIFICATION",
    LOAD_VIEW: "LOAD_VIEW"
}

export const OPERATION_TYPES = {
    ROUTE_READY_FOR_DISPATCH: "ROUTE_READY_FOR_DISPATCH"
}


// WEBPACK FOOTER //
// ./src/components/util/Constants.js